<template>
  <div class="committee  hideScrollbar">
    <div>
      <ul v-for="(item,index) in committee" :key="index">
        <li class="item">
          <span @click="openRegulations(item)">{{item.regulations_name}}</span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span @click="downloadRegulations(item)" class="icon">
            <font-awesome-icon icon="arrow-alt-circle-down" />
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import Bus from "@/misc/bus.js";
  export default {
    computed: {
      showPayment() {
        return this.$store.state.payment.showPayment;
      },
      committee() {
        return this.$store.state.regulations.committee;
      }
    },
    methods: {
      openRegulations(params) {
        const {
          href
        } = this.$router.resolve({
          path: "/showRegulations",
          query: {
            committee: params.committee,
            regulations_code: params.regulations_code,
            regulations_name: params.regulations_name
          }
        });
        window.open(href, "_blank");
      },
      downloadRegulations(params) {
        this.$store.dispatch("users/getConsumptionHistory");
        this.$store.dispatch("users/getUserInfo");
        Bus.$emit("showUserCenter", true);
        Bus.$emit("paied", false);
        this.$store.dispatch("order/setRechargeInfo", 5000);
        this.$store.dispatch("order/setOnceInfo", {
          description: params.regulations_name,
          category: "regulations_download",
          code: params.regulations_code,
          total_fee: 98, //单位分
          order_number: new Date().getTime(),
          body: "法规下载" // 发给微信端的订单描述
        });
      }
    }
  };
</script>

<style scope>
  .committee {
    margin-top: 0.1rem;
    height: calc(100vh - 2.3rem);
    padding-bottom: 0.1rem
  }

  .committee ul {
    margin-left: 0.15rem;
    padding-left: 0rem;
  }

  .committee .item {
    margin-top: 0.1rem
  }

  .committee .item:hover {
    color: black;
    background-color: #ccc;
    cursor: pointer;
  }

  .committee .icon:hover {
    color: red;
    background-color: #ccc;
    cursor: pointer;
  }
</style>